import { render, staticRenderFns } from "./bidAnnouncementPublish.vue?vue&type=template&id=cf2d63e2&scoped=true"
import script from "./bidAnnouncementPublish.vue?vue&type=script&lang=js"
export * from "./bidAnnouncementPublish.vue?vue&type=script&lang=js"
import style0 from "./bidAnnouncementPublish.vue?vue&type=style&index=0&id=cf2d63e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2d63e2",
  null
  
)

export default component.exports